@for (el of ticketPrices; track el; let i = $index) {
  <tw-client-ticket-line [ticketPrice]="el" (displayPdf)="displayPdfFile($event)"></tw-client-ticket-line>
}
